




import Vue from "vue"
import Component, { mixins } from "vue-class-component"

import { webComponentThemeProps, WebComponentThemeMixin } from '@/mixins'

import store from "@/store/index"
import "@/filters.js"

Vue.prototype.$theme = store.getters['config/theme'];

Vue.config.productionTip = false

@Component({
  store,
  props: {
    ...webComponentThemeProps
  }
})
export default class BuysideTheme extends mixins(WebComponentThemeMixin) {}
